<template>
  <a-layout id="components-layout-demo-custom-trigger" class="home-container">
<!--    <div style="overflow: hidden;">-->
<!--      <a-card style="box-sizing: border-box; border-radius: 0 !important">-->
<!--        <div  class="wps" >-->
<!--          <div class="biaoti" style="cursor: pointer" @click="homepay">-->
<!--            <div class="boxw">-->
<!--              <img :src="httplogo" style=" margin-top: -14px; padding-right: 10px; margin-left: 10px; width: 65px;height: 60px;"-->
<!--              />-->
<!--            </div>-->
<!--            {{ configdata.projectname }}-->
<!--          </div>-->
<!--          <div style="text-align: center;display: flex;flex-direction: row;justify-content:space-between;width: 855px ">-->

<!--          </div>-->
<!--        </div>-->
<!--      </a-card>-->
<!--    </div>-->
    <Header></Header>

<!--    <div style="height: 80px"></div>-->

    <div style="">
      <img :src="banner" style="display:block;width:100%;height:410px;margin: 0 auto"/>

      <div class="box_title">
        <div style="display:block;width: 1920px;justify-content: flex-start;">
          <img :src="selfhelpicon" style="width: 115px;height: 22.2px;margin:10px 20px " />
        </div>
      </div>
      <div class="box_menu">
        <div class="box_menu_list" @click="titleClick(1,0)">
          <div class="box_menu_list_img_one box_menu_list_img"></div>
<!--          <img class="box_menu_list_img" name="OneUrl" :src="OneUrl" onmouseout="mouseOver()" onmouseover="mouseOut()">-->
          <span class="box_menu_list_title">证书订购</span>
          <div class="box_menu_list_tishi">轻松订购，安全保障</div>
        </div>
        <div class="box_menu_list" @click="titleClick(8,0)">
          <div class="box_menu_list_img_three box_menu_list_img"></div>
<!--          <img class="box_menu_list_img" src="@/assets/home/menu_3.png">-->
          <span class="box_menu_list_title">年费服务</span>
          <div class="box_menu_list_tishi">尊享服务，快乐无忧</div>
        </div>
        <div class="box_menu_list" @click="titleClick(6,0)">
          <div class="box_menu_list_img_four box_menu_list_img"></div>
<!--          <img class="box_menu_list_img" src="@/assets/home/menu_4.png">-->
          <span class="box_menu_list_title">证书检测</span>
          <div class="box_menu_list_tishi">证书状态，一目了然</div>
        </div>
        <div class="box_menu_list" @click="titleClick(3,0)">
          <div class="box_menu_list_img_five box_menu_list_img"></div>
<!--          <img class="box_menu_list_img" src="@/assets/home/menu_5.png">-->
          <span class="box_menu_list_title">订单查询</span>
          <div class="box_menu_list_tishi">证书订单，一键查询</div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </a-layout>
</template>
<script>
import {conf_list} from "@/api/manage";
import logoimg from '@/assets/images/logo.png'
import Footer from "@/components/footer";
import Header from "@/components/heard";
import banners from '@/assets/images/banner.jpg'
import selfhelpicons from '@/assets/selfhelpicon.png'
export default {
  components: {Footer,Header},
  data() {
    return {
      banner:banners,
      selfhelpicon:selfhelpicons,
      province:'',
      OneUrl: require('@/assets/home/menu_1.png'),
      httplogo:'',
      logoimg:logoimg,
      titlekey:1,
      current: ["mail"],
      collapsed: false,
      configdata: {},
      openKeys: [],
      value1: new Date(2016, 9, 10, 18, 40),
      value2: new Date(2016, 9, 10, 18, 40),
    };
  },
  created() {
    this.httplogo = "/imgs/" + window.location.hostname + "/logo.png"
    // var configdata =  JSON.parse(localStorage.getItem('configdata'))
    // this.configdata = configdata
    // this.province = configdata.province
  },
  methods: {

    gohome(){
      window.location.replace("/");
    },
    gokefu(){
      window.open('http://service.xahuadao.com/chat/pc?token=dd58500b04dfaa2f68f2cb59da614644&noCanClose=1','_blank')
    },
    homepay() {
      window.location.replace("/");
    },
    titleClick(key, even) {
      this.titlekey=key;
      if (key == 1) {
        this.$router.push("/index")
      } else if (key == 2) {
        this.$router.push("/seal/index");
      } else if (key == 3 || key == 4 || key == 5) {
        this.$router.push("/orderlist");
      } else if (key == 6) {
        this.$router.push("/cost/check");//seal
      }else if (key == 7) {
        this.$router.push("/orderlist");
      }else if (key == 8) {
        this.$router.push("/cost/index");
        // if( this.province == '山东'){
        //   this.$router.push("/cost/index");
        // }else{
        //   this.$message({
        //     message: '陕西暂未开展此业务，感谢您的关注',
        //     type: 'warning'
        //   });
        // }
      }
    },
  },
};
</script>
<style lang="css" scoped>
@import "../../components/heard/pay.css";




.home-container {
  height: 100%;
}
.navitem{font-size: 15px;color: #FFFFFF}
.navitem:hover{cursor: pointer}
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #093d77;
}

#components-layout-demo-custom-trigger .logo {
  padding: 0;
  height: 32px;
  /*background: rgba(255, 255, 255, 0.2);/*/
  background: #001529;
  margin: 16px;
}

body {
  background-color: #fff !important;
}

b {
  color: #333;
}


.wps {
  /*background: #f5f5f5;*/
  background: #f9f9f9;
  display: flex;
  justify-content: space-around;
  height: 85px;
  line-height: 85px;
  text-align: center;
  align-items: center;
  border-bottom: 1px solid #c9c9c9;
  box-shadow: 0 -1px 5px rgb(0 0 0 / 10%);
}

.boxw {
  display: block;
  width: 100px;
  height: 85px;
  font-size: 46px;
  color: #FFFFFF;
  font-weight: 500;
  font-family: Microsoft YaHei UI Light;
  border-radius: 15px;
}

.biaoti {
  color: #000;
  display: flex;
  flex-direction: row;
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  font-family: "黑体";
}

.ant-carousel >>> .slick-slide img {
  border: 5px solid #fff;
  display: block;
  margin: auto;
  max-width: 60%;
}

.ant-carousel >>> .slick-thumb {
  bottom: -45px;
}

.ant-carousel >>> .slick-thumb li {
  width: 60px;
  height: 45px;
}

.ant-carousel >>> .slick-thumb li img {
  width: 100%;
  height: 100%;
  filter: grayscale(100%);
}

.ant-carousel >>> .slick-thumb li.slick-active img {
  filter: grayscale(0%);
}

#ok .ant-form-item-label label::after {
  content: "";
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}


.position_contbot span {
  display: block;
  height: 35px;
  line-height: 20px;
  padding: 7px 25px;
  color: #fff;
  margin-top: 5px;
  border-radius: 5px;
  box-sizing: border-box;
  background: #4278ff;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.box_title{
  display: flex;
  justify-content:center;
  width: 100%;
  height: 40px;
  color: #fff;
  background-color: #ffa800;
}

.box_menu{
  display: flex;
  flex-direction: row;
  padding:  20px 0 20px;
  box-sizing: border-box;
  min-width: 800px;
  max-width: 1920px;
  overflow-x: hidden;
  margin: 0 auto;
}

.box_menu_list{
  display: flex;
  flex-direction: column;
  width: 25%;
  cursor: pointer;
  overflow: hidden;
}

.box_menu_list_img{
  display: block;
  width: 80px;
  height: 80px;
  margin:  10px auto;
}

.box_menu_list_img_one{
  background: url('./images/menu_1.png') no-repeat ;
  background-size: 100% 100%;
}
.box_menu_list_img_one:hover{
  background: url('./images/menu_red_1.png') no-repeat;
  background-size: 100% 100%;
}

.box_menu_list_img_two{
  background: url('./images/menu_2.png') no-repeat ;
  background-size: 100% 100%;
}
.box_menu_list_img_two:hover{
  background: url('./images/menu_red_2.png') no-repeat ;
  background-size: 100% 100%;
}

.box_menu_list_img_three{
  background: url('./images/menu_3.png') no-repeat ;
  background-size: 100% 100%;
}
.box_menu_list_img_three:hover{
  background: url('./images/menu_red_3.png') no-repeat ;
  background-size: 100% 100%;
}

.box_menu_list_img_four{
  background: url('./images/menu_4.png') no-repeat ;
  background-size: 100% 100%;
}
.box_menu_list_img_four:hover{
  background: url('./images/menu_red_4.png') no-repeat ;
  background-size: 100% 100%;
}

.box_menu_list_img_five{
  background: url('./images/menu_5.png') no-repeat ;
  background-size: 100% 100%;
}
.box_menu_list_img_five:hover{
  background: url('./images/menu_red_5.png') no-repeat ;
  background-size: 100% 100%;
}

.box_menu_list_title{
  display: block;
  line-height: 50px;
  font-size: 18px;
  text-align: center;

}

.box_menu_list_tishi{
  display: none;
  line-height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
  text-align: center;
  color: #C52720;
}
.box_menu_list:hover .box_menu_list_title{
  color: #C52720;
}

.box_menu_list:hover .box_menu_list_tishi{
  display: block;
}




</style>
